"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateTestUsersResponseToJSON = exports.GenerateTestUsersResponseFromJSONTyped = exports.GenerateTestUsersResponseFromJSON = void 0;
var _1 = require("./");
function GenerateTestUsersResponseFromJSON(json) {
    return GenerateTestUsersResponseFromJSONTyped(json, false);
}
exports.GenerateTestUsersResponseFromJSON = GenerateTestUsersResponseFromJSON;
function GenerateTestUsersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'users': (json['users'].map(_1.UserFromJSON)),
    };
}
exports.GenerateTestUsersResponseFromJSONTyped = GenerateTestUsersResponseFromJSONTyped;
function GenerateTestUsersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'users': (value.users.map(_1.UserToJSON)),
    };
}
exports.GenerateTestUsersResponseToJSON = GenerateTestUsersResponseToJSON;
